/*
 * Abonare la newsletter - Parfumelo.
 *
 * Trimiterea formularelor e complet nativa (POST cu reincarcare). Nu se poate
 * face prin fetch: magazinul are protectie anti-spam, iar tokenul CAPTCHA e
 * atasat doar la o trimitere reala. Un POST din JS primeste 400 "Missing
 * CAPTCHA token". Confirmarea o randeaza Shopify prin form.posted_successfully?,
 * deci abonarea merge si cu JavaScript oprit.
 *
 * Rolul acestui fisier: cand se arata popupul si cand nu.
 */
(function () {
  'use strict';

  var CHEIE_ABONAT = 'parfumelo:newsletter:abonat';
  var CHEIE_INCHIS = 'parfumelo:newsletter:inchis';
  var CHEIE_DIN_POPUP = 'parfumelo:newsletter:din-popup';
  var ZILE_PAUZA = 14;

  var CFG = { popup: true, intarziere: 12 };
  try {
    var brut = document.getElementById('parfumelo-config');
    if (brut) {
      var j = JSON.parse(brut.textContent);
      if (j.newsletter) CFG = Object.assign(CFG, j.newsletter);
    }
  } catch (e) {
    /* valorile implicite */
  }

  /* ---------- stocare ---------- */

  function local(cheie, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(cheie);
      window.localStorage.setItem(cheie, val);
    } catch (e) { return null; }
  }
  function sesiune(cheie, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(cheie);
      window.sessionStorage.setItem(cheie, val);
    } catch (e) { return null; }
  }
  function stergeSesiune(cheie) {
    try { window.sessionStorage.removeItem(cheie); } catch (e) {}
  }

  function esteAbonat() { return local(CHEIE_ABONAT) === '1'; }

  function inchisRecent() {
    var t = parseInt(local(CHEIE_INCHIS) || '0', 10);
    return t ? Date.now() - t < ZILE_PAUZA * 24 * 60 * 60 * 1000 : false;
  }

  /* ---------- popup ---------- */

  var popup = null;

  function deschide() {
    if (!popup || !popup.hidden) return;
    popup.hidden = false;
    document.addEventListener('keydown', peEscape);
    var camp = popup.querySelector('input[type="email"]');
    if (camp) window.setTimeout(function () { camp.focus(); }, 60);
  }

  function inchide(marcheaza) {
    if (!popup || popup.hidden) return;
    if (marcheaza) local(CHEIE_INCHIS, String(Date.now()));
    popup.hidden = true;
    document.removeEventListener('keydown', peEscape);
  }

  function peEscape(ev) { if (ev.key === 'Escape') inchide(true); }

  function poateAparea() {
    if (!popup) return false;
    if (!CFG.popup) return false;
    if (esteAbonat()) return false;
    if (inchisRecent()) return false;
    // pe pagina dedicata de abonare popupul ar fi redundant
    if (/\/pages\/abonare/.test(window.location.pathname)) return false;
    if (/\/checkouts?\//.test(window.location.pathname)) return false;
    // pe pagina de produs popupul cade exact peste momentul deciziei
    if (/\/products\//.test(window.location.pathname)) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    return true;
  }

  /* ---------- pornire ---------- */

  function legaInchiderea() {
    if (!popup) return;
    var x = popup.querySelector('[data-pf-news-inchide]');
    var fundal = popup.querySelector('[data-pf-news-fundal]');
    if (x) x.addEventListener('click', function () { inchide(true); });
    if (fundal) fundal.addEventListener('click', function () { inchide(true); });
  }

  function porneste() {
    popup = document.querySelector('[data-pf-news-popup]');

    // Inchiderea se leaga intotdeauna, inainte de orice iesire din functie.
    // Altfel, dupa o abonare reusita din popup ajungeam sa-l deschidem ca sa
    // arate confirmarea, dar fara ascultatori pe X si pe fundal: ramanea blocat.
    legaInchiderea();

    // Shopify a randat confirmarea: abonarea a reusit
    if (document.querySelector('[data-pf-news-ok]')) {
      local(CHEIE_ABONAT, '1');
      // daca trimiterea a plecat din popup, il redeschidem ca sa vada confirmarea
      if (popup && sesiune(CHEIE_DIN_POPUP) === '1') {
        stergeSesiune(CHEIE_DIN_POPUP);
        deschide();
      }
      return;
    }

    if (!popup) return;

    // marcam ca trimiterea vine din popup, ca sa stim dupa reincarcare
    var form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        sesiune(CHEIE_DIN_POPUP, '1');
      });
    }

    if (poateAparea()) {
      window.setTimeout(function () {
        if (poateAparea()) deschide();
      }, (CFG.intarziere || 12) * 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  window.ParfumeloNewsletter = {
    deschide: deschide,
    inchide: inchide,
    reseteaza: function () {
      try {
        window.localStorage.removeItem(CHEIE_ABONAT);
        window.localStorage.removeItem(CHEIE_INCHIS);
        window.sessionStorage.removeItem(CHEIE_DIN_POPUP);
      } catch (e) {}
    },
    stare: function () {
      return {
        abonat: esteAbonat(),
        inchisRecent: inchisRecent(),
        poateAparea: poateAparea(),
        popupInPagina: !!popup,
      };
    },
  };
})();
